import React from 'react'

const SignInPage = () => {
  return (
    <>
    Im Signin Page
    </>
  )
}

export default SignInPage